import React, { useEffect, useState } from 'react';
import { sgsstCondiciones } from '../services/api';
import SgsstTabs from '../components/SgsstTabs';
import { S, F, Grid, Grid3, Modal, useFlash, fdate, dateVal } from '../components/sgsstUi';

const TIPO = { acto_inseguro: 'Acto inseguro', condicion_insegura: 'Condición insegura', observacion: 'Observación' };
const RIESGO = { bajo: '#10b981', medio: '#f59e0b', alto: '#ef4444' };
const hoy = () => new Date().toISOString().slice(0, 10);
const VACIO = { tipo: 'condicion_insegura', fecha: hoy(), lugar: '', area: '', descripcion: '', reportado_por: '', nivel_riesgo: 'medio', estado: 'abierto' };

export default function SgsstCondiciones() {
  const [lista, setLista] = useState([]);
  const [m, setM] = useState(null);
  const [msgNode, flash] = useFlash();
  const [busy, setBusy] = useState(false);

  const load = () => sgsstCondiciones.list().then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const guardar = async () => {
    if (!m.form.descripcion?.trim()) return flash(false, 'Describe la condición');
    setBusy(true);
    try { if (m.id) await sgsstCondiciones.update(m.id, m.form); else await sgsstCondiciones.create(m.form); setM(null); load(); flash(true, '✅ Guardado'); }
    catch (e) { flash(false, '❌ ' + (e.response?.data?.error || 'No se pudo')); } finally { setBusy(false); }
  };
  const borrar = async (r) => { if (!window.confirm('¿Eliminar el reporte?')) return; try { await sgsstCondiciones.remove(r.id); load(); } catch (e) {} };

  return (
    <div style={S.wrap}>
      <SgsstTabs />
      <div style={S.head}>
        <div><h1 style={S.h1}>Actos y condiciones inseguras</h1><p style={S.sub}>Reportes de seguridad para intervención temprana.</p></div>
        <button style={S.btn} onClick={() => setM({ form: { ...VACIO } })}>+ Nuevo reporte</button>
      </div>
      {msgNode}
      <div style={S.card}><div style={{ overflowX: 'auto' }}>
        <table style={S.table}>
          <thead><tr>{['Fecha', 'Tipo', 'Descripción', 'Lugar', 'Riesgo', 'Estado', ''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={7} style={S.empty}>Sin reportes.</td></tr>}
            {lista.map(r => (
              <tr key={r.id}>
                <td style={S.td}>{fdate(r.fecha)}</td>
                <td style={S.td}>{TIPO[r.tipo] || r.tipo}</td>
                <td style={{ ...S.td, color: '#e2e8f0' }}>{r.descripcion}</td>
                <td style={S.td}>{r.lugar || '—'}</td>
                <td style={S.td}><span style={{ ...S.badge, background: (RIESGO[r.nivel_riesgo] || '#666') + '22', color: RIESGO[r.nivel_riesgo] || '#999' }}>{r.nivel_riesgo}</span></td>
                <td style={S.td}><span style={{ ...S.badge, background: r.estado === 'cerrado' ? '#10b98122' : '#94a3b822', color: r.estado === 'cerrado' ? '#10b981' : '#94a3b8' }}>{r.estado}</span></td>
                <td style={S.td}><button style={S.link} onClick={() => setM({ id: r.id, form: { ...VACIO, ...r, fecha: dateVal(r.fecha) } })}>Editar</button><button style={{ ...S.link, color: '#fca5a5' }} onClick={() => borrar(r)}>Eliminar</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div></div>

      {m && <Modal title={m.id ? 'Editar reporte' : 'Nuevo reporte'} onClose={() => setM(null)}>
        <Grid>
          <F l="Tipo"><select style={S.in} value={m.form.tipo} onChange={e => setM({ ...m, form: { ...m.form, tipo: e.target.value } })}>{Object.entries(TIPO).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></F>
          <F l="Fecha"><input type="date" style={S.in} value={m.form.fecha} onChange={e => setM({ ...m, form: { ...m.form, fecha: e.target.value } })} /></F>
        </Grid>
        <F l="Descripción"><textarea style={S.ta} value={m.form.descripcion} onChange={e => setM({ ...m, form: { ...m.form, descripcion: e.target.value } })} /></F>
        <Grid>
          <F l="Lugar"><input style={S.in} value={m.form.lugar} onChange={e => setM({ ...m, form: { ...m.form, lugar: e.target.value } })} /></F>
          <F l="Área"><input style={S.in} value={m.form.area} onChange={e => setM({ ...m, form: { ...m.form, area: e.target.value } })} /></F>
        </Grid>
        <Grid3>
          <F l="Reportado por"><input style={S.in} value={m.form.reportado_por} onChange={e => setM({ ...m, form: { ...m.form, reportado_por: e.target.value } })} /></F>
          <F l="Nivel de riesgo"><select style={S.in} value={m.form.nivel_riesgo} onChange={e => setM({ ...m, form: { ...m.form, nivel_riesgo: e.target.value } })}>{['bajo', 'medio', 'alto'].map(o => <option key={o} value={o}>{o}</option>)}</select></F>
          <F l="Estado"><select style={S.in} value={m.form.estado} onChange={e => setM({ ...m, form: { ...m.form, estado: e.target.value } })}>{['abierto', 'cerrado'].map(o => <option key={o} value={o}>{o}</option>)}</select></F>
        </Grid3>
        <div style={S.modalBtns}><button style={S.btnGhost} onClick={() => setM(null)}>Cancelar</button><button style={S.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button></div>
      </Modal>}
    </div>
  );
}
